export const paragraphStyles = [
  {value: 'h1', label: 'Heading 1', isSelectable: true},
  {value: 'h2', label: 'Heading 2', isSelectable: true},
  {value: 'h3', label: 'Heading 3', isSelectable: true},
  {value: 'h4', label: 'Heading 4', isSelectable: true},
  {value: 'h5', label: 'Heading 5', isSelectable: true},
  {value: 'h6', label: 'Heading 6', isSelectable: true},
  {value: 'p', label: 'Paragraph', isSelectable: true},
  {value: 'pre', label: 'Preformatted', isSelectable: true},
  {value: 'blockquote', label: 'Quote', isSelectable: true},
  {value: 'li', label: 'List Item', isSelectable: false},
];

export const urlActions = [
  {value: 'url', label: 'Go to URL'}
  // {value: 'external_lightbox', label: 'Go to URL in Lightbox'},
  // {value: 'internal_lightbox', label: 'Show a lightbox'}
];

export const actionTargets = [
  {value: '_self', label: 'Same tab or window'},
  {value: '_blank', label: 'New tab or window'},
  {value: '_top', label: 'Topmost frame'},
  {value: '_parent', label: 'Parent frame'}
];



// WEBPACK FOOTER //
// ./src/ui/inline-text/style-tab-content-components/text-panel-defaults.js